var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indicator-container"},[(_vm.state)?_c('div',{staticClass:"state",class:( _obj = {}, _obj[_vm.state] = true, _obj )},[_vm._v(_vm._s(_vm.state))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }